import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import { Subject, forkJoin } from 'rxjs';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';

@Injectable({
  providedIn: 'root'
})
export class SyncfusionTranslationService {
  public onLanguageChanged = new Subject<string>();

  constructor(private http: HttpClient) { }

  public use(language: string) {
    const syncfusionLang = this.getSyncfusionLanguageName(language);
    forkJoin ({
      cldrCaGregorian: this.http.get(`/assets/cldr-data/${language}/ca-gregorian.json`, {responseType: 'json'}),
      cldrNumbers: this.http.get(`/assets/cldr-data/${language}/numbers.json`, {responseType: 'json'}),
      cldrTimeZoneNames: this.http.get(`/assets/cldr-data/${language}/timeZoneNames.json`, {responseType: 'json'}),
      syncfusion: this.http.get(`/assets/i18n-syncfusion/${syncfusionLang}.json`, {responseType: 'json'})
    }).subscribe(data => {
      loadCldr(
        numberingSystems,
        data.cldrCaGregorian,
        data.cldrNumbers,
        data.cldrTimeZoneNames,
        weekData // To load the culture based first day of week
      );
      let syncfusionData = {} as any;
      syncfusionData[language] = (data.syncfusion as any)[syncfusionLang];
      L10n.load(syncfusionData);
      setCulture(language);
      this.onLanguageChanged.next(language);
    });
  }

  private getSyncfusionLanguageName(language: string): string {
    if (language === 'en') {
      return 'en-US';
    }
    return language;
  }
}
